import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useLocation, matchPath } from "react-router-dom";

const NavItem = ({ listItemTitle, listItemLink, classNames }) => {
    const { pathname } = useLocation();
    const isCurrentPage = (path) =>{
        var props = {
            
        };
        if(matchPath({ path: path }, pathname)){
            props["aria-current"]='page';
        }
        return props;
    }

  return (
    /** <Nav.Link /> vs <Link />: refresh vs redirect */
    <Nav.Link as={Link} to={listItemLink} {...isCurrentPage(listItemLink)} className={classNames!=null ? classNames + " topNavMenuItem" : "topNavMenuItem"}>
      {listItemTitle}
    </Nav.Link>
    
  )
}

export default NavItem;